import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import CustomNavigate from '../components/CustomNavigate';

export default function EmailNonVerifiedMiddleware ({ children, route = '/dashboard/home' }) {
  const { user } = useAuth();
  const location = useLocation();

  const hasInvitation = new URLSearchParams(location.search).has('organizationInvitationToken');

  if(user?.emailVerified) return <CustomNavigate to={hasInvitation ? '/auth/accept-invitation' : route} />;
  return children;
}

EmailNonVerifiedMiddleware.propTypes = {
  children: PropTypes.node.isRequired
};